import * as React from 'react';
import Container from '@mui/material/Container';
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import CssBaseline from "@mui/material/CssBaseline/CssBaseline";
import Typography from "@mui/material/Typography/Typography";
import Grid from "@mui/material/Grid/Grid";
import Box from "@mui/material/Box/Box";
import TextField from "@mui/material/TextField/TextField";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import Button from "@mui/material/Button/Button";
import { useFormik } from 'formik';
import CompanyDetailsValidation from "../../validation/companyDetailsValidation";
import firebase from '../../firebase/firebase'
import {useNavigate} from "react-router-dom";
import ScrollToTop from '../../utils/scrollTop';



export default function CompanyDetails() {
  const navigator = useNavigate();
  const formik = useFormik({
    initialValues: CompanyDetailsValidation.initialValues,
    validationSchema: CompanyDetailsValidation.joinusSchema,
    onSubmit: async (values) => {
      const companyRef = firebase.firestore().collection('companyDetails');

      await  companyRef.add({
        ...values,
        uid: JSON.parse(window.localStorage.getItem('user')).uid,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      })
      navigator('/investor/membership-plan')
    },
  });
  return (
    <>
    <ScrollToTop/>
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
      <Container maxWidth="md" component="main" sx={{ pt: 4, }}>
        <Typography variant="h3" align="center" color="text.primary" component="p">
          Logo
        </Typography>
      </Container>
      <Container maxWidth="md" component="main" sx={{ pt: 4, }}>
        <Typography variant="h4" align="center" color="text.secondary" component="p">
          Company details
        </Typography>
      </Container>
      <Container maxWidth="md" component="main" sx={{ pt: 5, }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box   component="form" onSubmit={formik.handleSubmit} sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              mb: 2,
              flexDirection:'column',
            }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    select
                    value={formik.values.type}
                    onChange={formik.handleChange}
                    error={formik.touched.type && Boolean(formik.errors.type)}
                    helperText={formik.touched.type && formik.errors.type}
                    label="Type" name="type" variant="standard" sx={{width:'90%', textAlign:'left'}}>
                    <MenuItem value={'Studio'}>
                      Studio
                    </MenuItem>
                    <MenuItem value={'Distribution Company'}>
                      Distribution Company
                    </MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    value={formik.values.companyRegisteredName}
                    onChange={formik.handleChange}
                    error={formik.touched.companyRegisteredName && Boolean(formik.errors.companyRegisteredName)}
                    helperText={formik.touched.companyRegisteredName && formik.errors.companyRegisteredName}
                    label="Company Registered Name" name="companyRegisteredName" variant="standard" sx={{width:'90%'}} />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    value={formik.values.registrationNumber}
                    onChange={formik.handleChange}
                    error={formik.touched.registrationNumber && Boolean(formik.errors.registrationNumber)}
                    helperText={formik.touched.registrationNumber && formik.errors.registrationNumber}
                    label="Registration Number" name="registrationNumber" variant="standard" sx={{width:'90%'}} />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    value={formik.values.registeredAddress}
                    onChange={formik.handleChange}
                    error={formik.touched.registeredAddress && Boolean(formik.errors.registeredAddress)}
                    helperText={formik.touched.registeredAddress && formik.errors.registeredAddress}
                    label="Registered Address" name="registeredAddress" variant="standard" sx={{width:'90%'}} />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    value={formik.values.taxIdentifier}
                    onChange={formik.handleChange}
                    error={formik.touched.taxIdentifier && Boolean(formik.errors.taxIdentifier)}
                    helperText={formik.touched.taxIdentifier && formik.errors.taxIdentifier}
                    label="Tax Identifier" name="taxIdentifier" variant="standard" sx={{width:'90%'}} />
                </Grid>

                <Grid item xs={12}>
                  <Button variant="contained" sx={{pt: 1.2, pb:1.2, pl: 5, pr:5,  }} type='submit'>Next</Button>
                </Grid>
              </Grid>

            </Box>
          </Grid>
        </Grid>
      </Container>
      </>
  )

}